const getBaseUrl = () => process.env.REACT_APP_BACKEND_URL || '';

export const getTenantId = () => localStorage.getItem('tenant_id') || '';

export const getUserId = () => localStorage.getItem('user_id') || null;

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export const apiFetch = async (path, options = {}) => {
  const response = await fetch(`${getBaseUrl()}${path}`, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...(options.headers || {}),
    },
  });
  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const body = await response.json();
      message = body.error || body.message || message;
    } catch {
      // ignore parse errors
    }
    throw new Error(message);
  }
  if (response.status === 204) return null;
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const emptyStr = (v) => (v === '' || v == null ? null : v);

export const emptyNum = (v) => (v === '' || v == null ? null : Number(v));
